//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Alert',
  data() {
    return {
      open: false,
      message: null,
      messageSize: null,
      buttonText: null,
      buttonType: null,
    };
  },
  created() {
    this.$container.eventBus.on('toggleAlert', (e) => {
      if (!this.open) {
        this.message = e.message;
        this.messageSize = e.messageSize || 'in-your-face';
        this.buttonText = e.buttonText || 'OK';
        this.buttonType = e.buttonType || 'primary';
        this.open = true;
      } else {
        this.open = false;
      }
    });
  },
  methods: {
    close() {
      this.open = false;
    },
  },
};
